"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = componentAliasResolver;
const enums_1 = require("../../enums");
const ObjectHelper_1 = require("@aurora/shared-utils/helpers/objects/ObjectHelper");
const sharedModuleRegistry_1 = require("../../sharedModuleRegistry");
function componentAliasResolver(alias) {
    const sharedComponentId = (0, ObjectHelper_1.enumFromValue)(enums_1.SharedComponent, alias);
    if (sharedComponentId) {
        return (0, sharedModuleRegistry_1.getModulePathForComponent)(sharedComponentId);
    }
    return null;
}
//# sourceMappingURL=ComponentAliasResolver.js.map